export const isAnswerCorrect = (userAnswer, correctResponses, type) => {
  // If no correct responses are defined, assume the answer is correct.
  if (correctResponses.length === 0) {
    return true;
  }

  if (type === "checkbox_group" || type === "custom_checkbox_group") {
    // For checkbox groups, if there's no answer or the answer is not an array, it's incorrect.
    if (!Array.isArray(userAnswer) || userAnswer.length === 0) {
      return false;
    }
    // Check that both arrays have the same length and that every answer is one of the correct responses.
    return (
      userAnswer.length === correctResponses.length &&
      userAnswer.every((ans) => correctResponses.includes(ans))
    );
  } else {
    // For other types, simply check if the answer is included in the correct responses.
    return correctResponses.includes(userAnswer);
  }
};
